module.exports = __webpack_public_path__ + "img/PipeElbow.b05238ad.png";